import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data.user))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    localStorage.setItem('token', res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data.user);
    } catch {}
  };

  // Role helpers
  const isMasterAdmin  = user?.role === 'master_admin';
  const isManager      = user?.role === 'manager';
  const hasAdminAccess = isMasterAdmin || isManager;

  // Permission check: master_admin always has all permissions
  const can = useCallback((module, action) => {
    if (!user) return false;
    if (user.role === 'master_admin') return true;
    return !!user.permissions?.[module]?.[action];
  }, [user]);

  return (
    <AuthContext.Provider value={{
      user, loading, login, register, logout, refreshUser,
      isMasterAdmin, isManager, hasAdminAccess, can,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
